<template>
	<!--
		⚠ **2026-09-28 한시 변경 — 서비스 종료 안내 팝업 때문이다. 끝나면 되돌린다.**

		`PopupLayer` 의 기본 폭이 480 인데 종료 안내 이미지가 **700** 이라 들어가지 않았다.
		🔴 **720 인 것은 오타가 아니다** — 안쪽 `div` 가 `pa-10`(좌우 10px씩)이라 720 이어야 이미지가 **정확히 700** 으로 그려진다.
		700 으로 두면 680 으로 축소되는데, **비정수 배율이라 픽셀이 뭉갠다.**
		`max` prop 은 원래 있었지만 **아무도 쓰지 않던 확장점**이라, 그것을 쓰는 것으로 해결했다.

		🔴 **되돌릴 때는 두 곳이다:**
			① `<PopupLayer>` 의 `:max="720"` 제거   → 기본값 480 으로 복귀
			② `<img>` 의 style 을 `class="width-100"` 로 복귀

		⚠ **이 소스는 4벌로 굽는다**(데일리콘·데일리샵·데일리기프트·온기프트).
			이번 배포는 **데일리샵·데일리기프트 두 벌만** 한다 —
			`--dest dist_shop` · `--dest dist_gift`. 나머지 둘은 옛 산출물 그대로 둔다.

		⭕ `img` 를 `width:100%` 에서 `max-width:100%` 로 바꾼 이유:
			`width:100%` 는 **원본보다 작은 이미지를 700 까지 늘려 흐려지게** 한다.
			`max-width` 는 원본 크기를 넘지 않으므로 기존 팝업이 영향받지 않는다.
	-->
	<PopupLayer
		v-if="is_popup"
		:max="720"
	>
		<template
			v-slot:body
		>
			<div class="pa-10 overflow-y-auto">
				<h6 class="bg-primary color-white pa-10">{{ item.popup_name }}</h6>
				<div class="bg-white pa-10 size-px-16">{{ item.popup_contents }}</div>
				<div
					class="bg-white"
				>
					<img :src="item.popup_img" style="max-width: 100%; height: auto;"/>
				</div>
				<div class="justify-space-between pa-10 bg-white top-line">
					<label>
						<input v-model="is_hide" type="checkbox" /> 오늘 하루 안보기
					</label>
					<button
						@click="offPopup"
					><v-icon name="close-circle">mdi-close-circle</v-icon></button>
				</div>
			</div>
		</template>
	</PopupLayer>

</template>

<script>
import PopupLayer from "@/view/Layout/PopupLayer";
export default {
	name: 'popup'
	,
	components: {PopupLayer},
	props: ['user', 'codes']
	, data: function(){
		return{
			items: []
			, item: {}
			, popup_index: 0
			, is_move: false
			, is_popup: false
			, is_hide: false
		}
	}
	, computed: {

	}
	, methods: {
		getData: async function(){
			try{
				const result = await this.$request.init({
					method: 'get'
					,url: 'main/getMainPopup'
					,data: {
					}
				})

				if(result.success){
					this.item = result.data
					if(this.item.uid){
						let t = localStorage.getItem('popup_' + this.item.uid + '_')
						if(!t){
							this.is_popup = true
						}else{
							let today = this.$date.getToday('-')
							if(t != today){
								this.is_popup = true
							}
						}
					}
				}else{
					throw result.message
				}
			}catch (e) {
				console.log(e)
				this.$bus.$emit('notify', { type: 'error', message: e})
			}
		}
		, offPopup: function(){
			if(this.is_hide){
				let today = this.$date.getToday('-')
				localStorage.setItem('popup_' + this.item.uid + '_', today)
			}
			this.is_popup = false
		}
	}
	, created() {
		this.getData()
	}
}
</script>

<style>

@media (max-width: 720px) {
	.box-main-popup {
		width: 100%; height: 120px;
		overflow: hidden;
		white-space: nowrap;
	}
	.box-main-popup > ul  {
		transition: left 0.5s;
	}

	.box-main-popup li {
		width: 100%;
		height: 180px;
	}

	.popup-bg-img {
		background-position: center center; background-size: cover; width: 100%; height: 120px;
	}

	.arrow-right {
		top: 0; right: -10.5px
	}
	.arrow-left {
		top: 0; left: -12.5px; z-index: 1;
	}
}
@media (min-width: 720px) {
	.box-main-popup {
		width: 100%; height: 400px;
		overflow: hidden;
		white-space: nowrap;
	}
	.box-main-popup > ul  {
		transition: left 0.5s;
	}

	.box-main-popup li {
		width: 100%;
		height: 400px;
	}

	.popup-bg-img {
		background-position: center center; background-size: cover; width: 100%; height: 400px;
	}


	.arrow-right {
		top: 0; right: 0
	}
	.arrow-left {
		top: 0; left: 0; z-index: 1;
	}
}

.popup-on {
	left: 0
}
.popup-off {
	left: -100%
}
</style>